import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; // @ts-check

import React, { useState } from 'react';
import { Box, Grid, Typography, TextField } from '@material-ui/core';
import uuid from 'uuid';
import Dimension from '../components/Dimension';
import Window from '../../../../../modal/Window';

var InsertPieChartDialog = function InsertPieChartDialog(_ref) {
  var onSubmit = _ref.onSubmit,
      onClose = _ref.onClose,
      _ref$widgetData = _ref.widgetData,
      widgetData = _ref$widgetData === void 0 ? null : _ref$widgetData;

  var _useState = useState(widgetData && widgetData.value),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(widgetData ? widgetData.startValue : 0),
      _useState4 = _slicedToArray(_useState3, 2),
      startValue = _useState4[0],
      setStartValue = _useState4[1];

  var _useState5 = useState(widgetData ? widgetData.endValue : 100),
      _useState6 = _slicedToArray(_useState5, 2),
      endValue = _useState6[0],
      setEndValue = _useState6[1];

  var _useState7 = useState(widgetData ? widgetData.majorTickCount : 10),
      _useState8 = _slicedToArray(_useState7, 2),
      majorTickCount = _useState8[0],
      setMajorTickCount = _useState8[1];

  return React.createElement(Window, {
    onClose: onClose,
    style: {
      width: 600
    },
    open: true,
    header: widgetData !== null ? 'Edit Gauge' : 'Insert Gauge',
    submitLabel: "Insert",
    labelPlacement: "top",
    variant: "filled",
    hideCancelButton: true,
    disableRestoreFocus: true,
    disableBackdropClick: true,
    renderContent: function renderContent() {
      return React.createElement(Box, {
        p: 3
      }, React.createElement(Grid, {
        container: true,
        direction: "column",
        spacing: 3
      }, React.createElement(Grid, {
        item: true
      }, React.createElement(Dimension, {
        variant: "outlined",
        label: "Value",
        onChange: setValue,
        dimension: value,
        hideFilter: true,
        hasFunction: true,
        forceFunction: true
      })), React.createElement(Grid, {
        item: true
      }, React.createElement(Typography, {
        gutterBottom: true
      }, "Min"), React.createElement(TextField, {
        variant: "outlined",
        value: startValue,
        onChange: function onChange(e) {
          return setStartValue(e.target.value);
        },
        inputProps: {
          type: 'number'
        }
      })), React.createElement(Grid, {
        item: true
      }, React.createElement(Typography, {
        gutterBottom: true
      }, "Max"), React.createElement(TextField, {
        variant: "outlined",
        value: endValue,
        onChange: function onChange(e) {
          return setEndValue(e.target.value);
        },
        inputProps: {
          type: 'number'
        }
      })), React.createElement(Grid, {
        item: true
      }, React.createElement(Typography, {
        gutterBottom: true
      }, "Major Ticks"), React.createElement(TextField, {
        variant: "outlined",
        value: majorTickCount,
        onChange: function onChange(e) {
          return setMajorTickCount(e.target.value);
        },
        inputProps: {
          type: 'number'
        }
      }))));
    },
    footerButtons: {
      submit: {
        onClick: function onClick() {
          return onSubmit({
            id: widgetData !== null ? widgetData.id : uuid(),
            value: value,
            startValue: startValue,
            endValue: endValue,
            majorTickCount: majorTickCount
          });
        },
        disabled: !value,
        children: 'OK'
      },
      cancel: {}
    }
  });
};

export default InsertPieChartDialog;